import { Component, Input, OnInit } from '@angular/core';
import { DimensionInformationEnum, TypeSignDimensionEnum } from 'src/enumerators';
import { HorizontalSignalingDimensionSettingTypeEnum } from 'src/enumerators/signaling-type.enum';
import { SettingsDimesionHorizontalData, SettingsDimesionTrafficData } from 'src/models';

@Component({
  selector: 'app-dimension-config-input',
  templateUrl: './dimension-config-input.component.html',
  styleUrls: ['./dimension-config-input.component.css']
})
export class DimensionConfigInputComponent implements OnInit {

  @Input() typeDimension: TypeSignDimensionEnum;
  @Input() dimensionItem: SettingsDimesionTrafficData;
  @Input() dimensionHorizontalItem: SettingsDimesionHorizontalData;
  @Input() index: number;

  typeSignDimensionEnum = TypeSignDimensionEnum;
  dimensionInformationEnum = DimensionInformationEnum;
  horizontalSignalingDimensionSettingTypeEnum = HorizontalSignalingDimensionSettingTypeEnum;

  constructor() { }

  ngOnInit(): void {
  }

  // Cálculo para o valor total de cada tipo de placa
  calculateDimension(idDimension) {
    if (this.typeDimension != this.typeSignDimensionEnum.Horizontal) {

      if (this.dimensionItem?.dimensionType == DimensionInformationEnum.Envolvente)
        this.dimensionItem.dimension =
          this.removeSpace(this.dimensionItem.dimensionX) * (this.removeSpace(this.dimensionItem.dimensionY));

      else {

        if (this.typeDimension == TypeSignDimensionEnum.Octagonal)
          this.dimensionItem.dimension =
            2 * (this.removeSpace(this.dimensionItem.dimensionY) ** 2) * (Math.sqrt(2) - 1);

        else if (this.typeDimension == TypeSignDimensionEnum.Triangular)
          this.dimensionItem.dimension =
            ((this.removeSpace(this.dimensionItem.dimensionY) ** 2) * (Math.sqrt(3))) / 3;

        else if (this.typeDimension == TypeSignDimensionEnum.Circular)
          this.dimensionItem.dimension =
            (this.removeSpace(this.dimensionItem.diameter) / 2) ** 2 * Math.PI;

        else
          this.dimensionItem.dimension = this.removeSpace(this.dimensionItem.sideLength) ** 2;
      }
      if (idDimension) (document.getElementById(idDimension) as HTMLInputElement).value = (this.dimensionItem.dimension ? this.dimensionItem.dimension.toFixed(5) : '');
    }

    else {
      if (HorizontalSignalingDimensionSettingTypeEnum.WithHeight)
        this.dimensionHorizontalItem.dimension = this.removeSpace(this.dimensionHorizontalItem.dimensionX) * this.removeSpace(this.dimensionHorizontalItem.dimensionY);
      else this.dimensionHorizontalItem.dimension = 0;

      if (idDimension) (document.getElementById(idDimension) as HTMLInputElement).value = (this.dimensionHorizontalItem.dimension ? this.dimensionHorizontalItem.dimension.toFixed(5) : '');
    }

    this.emitDimensionInformation();
  }

  // Recebe a string e troca ' ' por ''
  removeSpace(value: any) {
    if (value) {
      let parsedValue = typeof value === 'number' ? value.toString() : value;
      let formatedValue = parsedValue.replace(' ', '');
      formatedValue = parsedValue.replace(',', '.');
      return formatedValue;
    } else {
      return null;
    }
  }

  // Emite os valores para o componente pai, ele apaga todos os valores que não são usados
  emitDimensionInformation() {
    if (this.typeDimension != this.typeSignDimensionEnum.Horizontal) {

      if (this.dimensionItem.dimensionType == DimensionInformationEnum.Envolvente) {
        this.dimensionItem.sideLength = 0;
        this.dimensionItem.diameter = 0;

      } else {
        if (this.typeDimension == TypeSignDimensionEnum.Circular) {
          this.dimensionItem.sideLength = 0;
          this.dimensionItem.dimensionX = 0;
          this.dimensionItem.dimensionY = 0;

        } else if (this.typeDimension == TypeSignDimensionEnum.Octagonal || this.typeDimension == TypeSignDimensionEnum.Triangular) {
          this.dimensionItem.diameter = 0;
          this.dimensionItem.sideLength = 0;
          this.dimensionItem.dimensionX = 0;

        } else {
          this.dimensionItem.diameter = 0;
          this.dimensionItem.dimensionX = 0;
          this.dimensionItem.dimensionY = 0;
        }
      }
    } else if (this.typeDimension == this.typeSignDimensionEnum.Horizontal) {
      if (this.dimensionHorizontalItem.type == HorizontalSignalingDimensionSettingTypeEnum.WithoutHeight) {
        this.dimensionHorizontalItem.dimension = 0;
        this.dimensionHorizontalItem.dimensionY = 0;
      }
    }

  }

  // Compara o tipo de dimensão passada com o tipo da sinalização
  checkedDimensionType(dimensionType): boolean {
    if (dimensionType == this.dimensionItem?.dimensionType) {
      return true;
    }
    return false;
  }

  // Compara o tipo de dimensão passada com o tipo da sinalização
  checkedDimensionHorizontalType(dimensionType): boolean {
    if (dimensionType == this.dimensionHorizontalItem?.type) {
      return true;
    }
    return false;
  }
}
